import { useParams } from 'react-router-dom'
import User from 'singletons/User'

const useVisit = () => {
  const { visitId } = useParams()
  return User.provider?.visitQueue.getById(visitId) || null
}

export default useVisit
